import styled from 'styled-components';

export const Root = styled.nav<{ $open: boolean }>`
  padding: ${({ theme }) => `${theme.shape.spacing(4)} 0px`};
  width: ${({ $open }) => (!$open ? '25px' : '100%')};
  opacity: ${({ $open }) => (!$open ? '0' : '1')};
  transition: all 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`;
